import { parsePhoneNumber } from "libphonenumber-js";

const mixins = {
	filters: {
		formatPhoneNumber(phoneNumber) {
			// TODO remove default country code if update API to use E.164 (+66876660591) format
			if(phoneNumber.length === 10)
				return parsePhoneNumber(phoneNumber, "TH").formatNational().split(" ").join("-");
			return phoneNumber.match(/.{1,3}/g).join("-")
		},
	},
	methods: {
		convertUnit(type) {
			if(type == 1){
				return this.$t('membership-tier.bath')
			}
			return this.$t('membership-tier.point')
		},
		convertUnitDiscount(val) {
            if (val == 1) return '%'
            return `${this.$t('membership-tier.bath')}`
        },
        convertMinimum(val) {
            if (val == 0) return `${this.$t('membership-tier.no-minimum')}`
            return `${this.$t('membership-tier.minimum')} ${val.toLocaleString()}`
        },
		getFormatPhoneNumber(phoneNumber) {
			return parsePhoneNumber(phoneNumber, "TH").formatNational().split(" ").join("-");
		},
		formatDuplicateText(word) {
			return word.replace(/(\w|[ก-ฮ]|[เ-ๆ])\1{4,}/g, (str, match) => `${match[0]}...`)
		},
		numberWithCommas(x) {
			if (x == 0 || !x) return 0;
			return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		},
		onlyNumber(evt) {
			evt = evt ? evt : window.event;
			var charCode = evt.which ? evt.which : evt.keyCode;
			if (charCode > 31 && (charCode < 48 || charCode > 57)) {
				evt.preventDefault();
			} else {
				return true;
			}
		},
		calPercentTier(ranking) {
			let percent = 0
			if (ranking) {
                const {
                    conditionValue,
                    spendingAccumulation,
					accumulationType,
					pointAccumulation
                } = ranking
                if (
                    !isNaN(conditionValue) &&
                    !isNaN(spendingAccumulation) &&
                    Number(conditionValue) > 0
                ) {
					if(accumulationType == 1){
						percent = (
							(Number(spendingAccumulation) /
								Number(conditionValue)) *
							100
						)
					}else{
						percent = (
							(Number(pointAccumulation) /
								Number(conditionValue)) *
							100
						)
					}
                }
            }
			if(percent > 100) percent = 100
			else if(percent < 0) percent = 0

            return percent
		},
		async digestMessage(message) {
			const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
			if (!crypto.subtle) {
				return "";
			}
			const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8); // hash the message
			const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array

			return btoa(String.fromCharCode(...new Uint8Array(hashArray)));
		},
		randomString(length) {
			const chars =
				"0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ-._~";
			let result = "";
			for (let i = length; i > 0; --i)
				result += chars[Math.floor(Math.random() * chars.length)];
			return result;
		},
		base64UrlEncode(str) {
			return str
				.replace(/\+/g, "-")
				.replace(/\//g, "_")
				.replace(/=/g, "");
		},
	},
}

export default mixins